import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import Brand from "@/components/site/Brand";

export default function Nav() {
  const { content } = useContent();
  const navLinks = content.nav || [];
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  // Visible only the 4 nav items requested + the brand & CTA.
  // "Kainos" is reachable via /kainos from project cards and footer.
  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-50 transition-all duration-500 bg-[#f9f8f6]/95 backdrop-blur-md border-b border-[#e5e2dd]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between h-[88px]">
        <div className="flex items-center">
          <Brand size="sm" />
        </div>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[11px] uppercase tracking-[0.26em] transition-colors ${
                  isActive
                    ? "text-[#a66e4b]"
                    : "text-[#1a1a1a] hover:text-[#a66e4b]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/kontaktai"
          data-testid="nav-cta"
          className="hidden"
          aria-hidden="true"
          tabIndex={-1}
        >
          Susisiekti
        </Link>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-[#1a1a1a]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Meniu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#f9f8f6] border-t border-[#e5e2dd]">
          <div className="px-6 py-8 flex flex-col gap-6">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={closeMenu}
                data-testid={`nav-mobile-link-${l.label
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.22em] ${
                    isActive ? "text-[#a66e4b]" : "text-[#1a1a1a]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
